export default "__VITE_PUBLIC_ASSET__12418b69__"